<template>
    <el-dialog :visible.sync="visible" :title="'班级争章进度'" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <div class="mod-class-decoration__manualconfig">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getPage()">
                <el-form-item style="float: right">
                    <el-button type="primary" @click="progressWorld()" style="float: right">{{ $t('export') }}</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="classProgressList" border @selection-change="dataListSelectionChangeHandle"
                      style="width: 100%;">
                <el-table-column prop="className" label="班级" header-align="center" align="center"></el-table-column>
                <el-table-column prop="studentNumber" label="总人数" header-align="center" align="center"></el-table-column>
                <el-table-column prop="decorationNum" label="争章数量" header-align="center" align="center"></el-table-column>
                <el-table-column prop="winDecorationNum" label="获章数量" header-align="center" align="center"></el-table-column>
            </el-table>
        </div>
<!--        <el-pagination-->
<!--                :current-page="page"-->
<!--                :page-sizes="[10, 20, 50, 100]"-->
<!--                :page-size="limit"-->
<!--                :total="total"-->
<!--                layout="total, sizes, prev, pager, next, jumper"-->
<!--                @size-change="pageSizeChangeHandle"-->
<!--                @current-change="pageCurrentChangeHandle">-->
<!--        </el-pagination>-->
        <template slot="footer">
            <el-button type="danger" @click="visible = false">关闭</el-button>
        </template>
    </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import Export2Excel from '../../../vendor/Export2Excel'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        // getDataListURL: '/decoration/manualConfig/classProgress',
        getDataListIsPage: false,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      visible: false,
      classProgressList: [],
      termTableId: '',
      dataForm: {
      }
    }
  },
  mounted () {
    this.getClassProgress()
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.dataForm.termTableId = this.termTableId
        this.getClassProgress()
      })
    },
    getClassProgress () {
      this.dataListLoading = true
      this.$http.get('decoration/manualConfig/classProgress', {
        params: {
          termTableId: this.dataForm.termTableId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classProgressList = res.data
        this.dataListLoading = false
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map((v) => {
        return filterVal.map((j) => v[j])
      })
    },
    progressWorld () {
        import('../../../vendor/Export2Excel').then((excel) => {
          // const schoolName = this.dataList[0].schoolName
          // 导出的表头名
          const multiHeader2 = [
            '红领巾争章汇总表'
          ]
          // 二行
          const multiHeader = [
          ] // 导出的表头名
          const filterVal = [
          ]
          const merges = [
            'A1:D1'
          ]
          // 导出的表头字段名
          const list = this.classProgressList // 把data里的tableData存到list
          multiHeader.push('班级')
          filterVal.push('className')
          multiHeader.push('总人数')
          filterVal.push('studentNumber')
          multiHeader.push('争章数量')
          filterVal.push('decorationNum')
          multiHeader.push('获章数量')
          filterVal.push('winDecorationNum')
          const data = this.formatJson(filterVal, list)
          const filterName = '红领巾争章汇总表'
          excel.export_json_excel({
            multiHeader2, // 这是算第一行的表头
            multiHeader, // 这里是第二行的表头
            data,
            merges,
            filename: filterName
          })
        })
    }
  }
}
</script>

<style scoped>

</style>
